module.exports = __webpack_public_path__ + "static/media/fulllogo.81523050.png";